import React from "react";
import { allRoutes } from "src/constants/AllRoutes";
import { PERMISSION, PERMISSION_VALUE } from "src/constants/permissionEnum";

// special permit routes

const SupplierAdd = React.lazy(() => import("src/screens/admin/SupplierManagement/SupplierAdd"));
const ViewSupplierDetails = React.lazy(() => import("src/screens/admin/SupplierManagement/ViewSupplierDetails"));
const AddNewService = React.lazy(() => import("src/screens/admin/ServiceManagement/AddNewService"));
const ServiceDetails = React.lazy(() => import("src/screens/admin/ServiceManagement/ServiceDetails"));
const RegionAdd = React.lazy(() => import("src/screens/admin/RegionManagement/RegionAdd"));
const AgencyAdd = React.lazy(() => import("src/screens/admin/AgencyManagement/AgencyAdd"));
const AgentAdd = React.lazy(() => import("src/screens/admin/AgentManagement/AgentAdd"));
const EventAdd = React.lazy(() => import("src/screens/admin/EventManagement/EventAdd"));
const EventDetails = React.lazy(() => import("src/screens/admin/EventManagement/EventDetails"));
const AddSubAdmin = React.lazy(() => import("src/screens/admin/SubAdmin/AddSubAdmin"));
const ViewSubAdmin = React.lazy(() => import("src/screens/admin/SubAdmin/ViewSubAdmin"));
const ItineraryAdd = React.lazy(() => import("src/screens/admin/ItineraryManagement/ItineraryAdd"));
const ViewItinerary = React.lazy(() => import("src/screens/admin/ItineraryManagement/pages/ViewItinerary"));
const GenerateQuotationDetails = React.lazy(() => import("src/screens/admin/ItineraryManagement/pages/GenerateQuotationDetails"));
const TermsConditionsDetails = React.lazy(() => import("src/screens/admin/TermsConditionsManagement/TermsConditionsDetails"));
const TermsConditionsManager = React.lazy(() => import("src/screens/admin/TermsConditionsManagement/TermsConditionsManager"));
const ItineraryServiceSchedule = React.lazy(() => import("src/screens/admin/ItineraryManagement/pages/ItineraryServiceSchedule"));
const ViewHotel = React.lazy(() => import("src/screens/admin/Hotels/ViewHotel"));
const AddHotelScreen = React.lazy(() => import("src/screens/admin/Hotels/AddHotelScreen"));

const permitRoutes = [
  { permission: { type: PERMISSION.itinerary, value: PERMISSION_VALUE.create }, path: allRoutes.itineraryAdd, component: ItineraryAdd },
  {
    permission: { type: PERMISSION.itinerary, value: PERMISSION_VALUE.update },
    path: allRoutes.itinerary + "/:id" + allRoutes.edit,
    component: ItineraryAdd
  },
  { permission: { type: PERMISSION.itinerary, value: PERMISSION_VALUE.read }, path: allRoutes.itinerary + "/:id", component: ViewItinerary },
  {
    permission: { type: PERMISSION.itinerary, value: PERMISSION_VALUE.read },
    path: allRoutes.itinerary + "/:id" + allRoutes.itineraryGenerateQuotationDetails,
    component: GenerateQuotationDetails
  },
  {
    permission: { type: PERMISSION.itinerary, value: PERMISSION_VALUE.read },
    path: allRoutes.itinerary + "/:id" + allRoutes.itineraryAddServiceSchedule,
    component: ItineraryServiceSchedule
  },
  { permission: { type: PERMISSION.event, value: PERMISSION_VALUE.create }, path: allRoutes.eventAdd, component: EventAdd },
  {
    permission: { type: PERMISSION.event, value: PERMISSION_VALUE.update },
    path: allRoutes.event + "/:id" + allRoutes.edit,
    component: EventAdd
  },
  { permission: { type: PERMISSION.event, value: PERMISSION_VALUE.read }, path: allRoutes.event + "/:id", component: EventDetails },

  { permission: { type: PERMISSION.supplier, value: PERMISSION_VALUE.create }, path: allRoutes.supplierAdd, component: SupplierAdd },
  {
    permission: { type: PERMISSION.supplier, value: PERMISSION_VALUE.update },
    path: allRoutes.suppliers + "/:id" + allRoutes.edit,
    component: SupplierAdd
  },
  { permission: { type: PERMISSION.supplier, value: PERMISSION_VALUE.read }, path: allRoutes.suppliers + "/:id", component: ViewSupplierDetails },
  { permission: { type: PERMISSION.services, value: PERMISSION_VALUE.create }, path: allRoutes.servicesAdd, component: AddNewService },
  {
    permission: { type: PERMISSION.services, value: PERMISSION_VALUE.update },
    path: allRoutes.services + "/:id" + allRoutes.edit,
    component: AddNewService
  },
  { permission: { type: PERMISSION.services, value: PERMISSION_VALUE.read }, path: allRoutes.services + "/:id", component: ServiceDetails },
  { permission: { type: PERMISSION.agency, value: PERMISSION_VALUE.create }, path: allRoutes.agencyAdd, component: AgencyAdd },
  {
    permission: { type: PERMISSION.agency, value: PERMISSION_VALUE.update },
    path: allRoutes.agency + "/:id" + allRoutes.edit,
    component: AgencyAdd
  },
  { permission: { type: PERMISSION.agent, value: PERMISSION_VALUE.create }, path: allRoutes.agentAdd, component: AgentAdd },
  {
    permission: { type: PERMISSION.agent, value: PERMISSION_VALUE.update },
    path: allRoutes.agent + "/:id" + allRoutes.edit,
    component: AgentAdd
  },
  { permission: { type: PERMISSION.region, value: PERMISSION_VALUE.create }, path: allRoutes.regionAdd, component: RegionAdd },
  {
    permission: { type: PERMISSION.region, value: PERMISSION_VALUE.update },
    path: allRoutes.region + "/:id" + allRoutes.edit,
    component: RegionAdd
  },
  {
    permission: { type: PERMISSION.termsCondition, value: PERMISSION_VALUE.create },
    path: allRoutes.termsConditionsAdd,
    component: TermsConditionsManager
  },
  {
    permission: { type: PERMISSION.termsCondition, value: PERMISSION_VALUE.update },
    path: allRoutes.termsConditions + "/:id" + allRoutes.edit,
    component: TermsConditionsManager
  },
  {
    permission: { type: PERMISSION.termsCondition, value: PERMISSION_VALUE.read },
    path: allRoutes.termsConditions + "/:id",
    component: TermsConditionsDetails
  },
  { permission: { type: PERMISSION.subAdmin, value: PERMISSION_VALUE.create }, path: allRoutes.subAdminAdd, component: AddSubAdmin },
  {
    permission: { type: PERMISSION.subAdmin, value: PERMISSION_VALUE.update },
    path: allRoutes.subAdmin + "/:id" + allRoutes.edit,
    component: AddSubAdmin
  },
  { permission: { type: PERMISSION.subAdmin, value: PERMISSION_VALUE.read }, path: allRoutes.subAdmin + "/:id", component: ViewSubAdmin },
  { permission: { type: PERMISSION.hotel, value: PERMISSION_VALUE.create }, path: allRoutes.hotelAdd, component: AddHotelScreen },
  {
    permission: { type: PERMISSION.hotel, value: PERMISSION_VALUE.update },
    path: allRoutes.hotels + "/:id" + allRoutes.edit,
    component: AddHotelScreen
  },
  { permission: { type: PERMISSION.hotel, value: PERMISSION_VALUE.read }, path: allRoutes.hotels + "/:id", component: ViewHotel }
];

export default permitRoutes;
